import React from "react";
import { Helmet } from "react-helmet";

const SEO = ({
  title,
  description,
  keywords,
  author = "Swadaa Security & Guards Limited",
  ogImage = "https://swadaaexpress.com/swadaa_security.png",
  url = "https://swadaaexpress.com",
  type = "website",
}) => {
  const defaultTitle =
    "Swadaa Security & Guards Limited | Professional Security & Community Empowerment";
  const defaultDescription =
    "Swadaa Security & Guards Limited delivers professional security guard services, surveillance, emergency response, and empowerment programs in Lagos and across Nigeria. We protect lives, property, and communities with integrity and local expertise.";
  const defaultKeywords =
    "Swadaa Security, security guards, surveillance, emergency response, empowerment programs, Lagos security company, private security services, community safety, women empowerment";

  const seoTitle = title
    ? `${title} | Swadaa Security & Guards Limited`
    : defaultTitle;
  const seoDescription = description || defaultDescription;
  const seoKeywords = keywords || defaultKeywords;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{seoTitle}</title>
      <meta name="title" content={seoTitle} />
      <meta name="description" content={seoDescription} />
      <meta name="keywords" content={seoKeywords} />
      <meta name="author" content={author} />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:image" content={ogImage} />
      <meta
        property="og:site_name"
        content="Swadaa Security & Guards Limited"
      />
      <meta property="og:locale" content="en_US" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={seoDescription} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="twitter:creator" content="@SwadaaSecurity" />
      <meta name="twitter:site" content="@SwadaaSecurity" />

      {/* Additional Meta Tags */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      <meta name="theme-color" content="#041a38" />
      <meta name="msapplication-TileColor" content="#041a38" />

      {/* Geo Tags */}
      <meta name="geo.region" content="NG-LA" />
      <meta name="geo.placename" content="Lagos, Nigeria" />

      {/* Contact Information */}
      <meta name="contact" content="swadaaexpress@gmail.com" />
      <meta name="organization" content="Swadaa Security & Guards Limited" />

      {/* JSON-LD Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "Swadaa Security & Guards Limited",
          alternateName: "Swadaa Security and Guards",
          url: url,
          logo: ogImage,
          contactPoint: {
            "@type": "ContactPoint",
            telephone: "+234-706-602-5588",
            contactType: "Customer Service",
            email: "swadaaexpress@gmail.com",
            areaServed: "Nigeria",
            availableLanguage: "English",
          },
          address: {
            "@type": "PostalAddress",
            streetAddress: "1, Balogun Street, Ajegunle, Ikorodu Road",
            addressLocality: "Lagos",
            addressCountry: "NG",
          },
          sameAs: [
            "https://www.facebook.com/swadaaexpress",
            "https://www.instagram.com/swadaaexpress",
          ],
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
